import service from '../utils/fetch';
import { stringify } from 'qs';

export async function queryTeacherHome(data) {
    return service('/zy/m/t/activity/winter/index', {
        method: 'POST',
        data: stringify(data),
    });
}


// WEBPACK FOOTER //
// ./src/views/winter-camp/api/home.js